import { SavedSearchResponse } from '@doda/api-client/aspida/@types';

/**
 * 保存した検索条件からoldestDayWdtnoに渡す値を取得
 * @param savedSearches
 * @returns number 最も古い条件番号
 */
export const getOldestDayWdtno = (savedSearches: SavedSearchResponse[]) => {
  if (!savedSearches.length) return 0;

  const sortedSavedSearches = savedSearches
    .map(({ no, savedDate }) => ({
      no,
      savedDate: new Date(savedDate),
    }))
    .sort((a, b) => a.savedDate.getTime() - b.savedDate.getTime());

  return sortedSavedSearches[0].no;
};
